<script>
  let {
    rowClass = null,
    keyClass = null,
    valueClass = null,
    extraRowClass = '',
    extraKeyClass = '',
    extraValueClass = '',
    key,
    value
  } = $props()

  const defaults = {
    row: 'row border-top',
    key: 'col-sm-4 p-0 pt-3 pb-3',
    value: 'col-sm-8 p-0 pt-sm-3 pb-3'
  }

  const computedRowClass = $derived(
    rowClass !== null
      ? rowClass
      : [defaults.row, extraRowClass].filter(Boolean).join(' ')
  )

  const computedKeyClass = $derived(
    keyClass !== null
      ? keyClass
      : [defaults.key, extraKeyClass].filter(Boolean).join(' ')
  )

  const computedValueClass = $derived(
    valueClass !== null
      ? valueClass
      : [defaults.value, extraValueClass].filter(Boolean).join(' ')
  )
</script>

<div class={computedRowClass}>
  <div class={computedKeyClass}>
    {@render key()}
  </div>

  <div class={computedValueClass}>
    {@render value()}
  </div>
</div>
